module.exports = __webpack_public_path__ + "media/images/logos/apple-441fc9deb1194e595fad6a839cc6896e.svg";